"use client";

import styled from "@emotion/styled";
import Link from "next/link";

export const StyledLink = styled(Link)`
  text-decoration: none !important;
  color: inherit !important;
  display: block;

  &:hover {
    text-decoration: none !important;
  }
`;
